import { render, staticRenderFns } from "./IconDocument.vue?vue&type=template&id=b6c15828"
import script from "./IconDocument.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconDocument.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports